import { render, staticRenderFns } from "./Secret.vue?vue&type=template&id=35641ea6&"
import script from "./Secret.vue?vue&type=script&lang=ts&"
export * from "./Secret.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports